// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchClients_root__1Z8H_","table":"SearchClients_table__3WOmc"};